var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"map-action with-icon animated",class:_vm.colour,on:{"click":_vm.onClick}},[_c('span',{staticClass:"icon",style:({'background-image': ("url(" + _vm.icon + ")")})}),_vm._v(" "),_vm._v("\n  "+_vm._s(_vm.title)+"\n  \n")])}
var staticRenderFns = []

export { render, staticRenderFns }